import { gql } from '@apollo/client';

export const ALL_SITES = gql`
  query AllSites($input: SitesInput!) {
    sites: allSites(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          startDate
          endDate
          status
          hierarchyLevelSubtype
          hierarchyLevel {
            id
            value
            typeOfSite
            hasSubtypes
            subtypes
          }
          parentSite {
            id
            name
          }
          hierarchy {
            id
            name
          }
          organisation {
            id
            isInstitution
            isServiceProvider
            isFunder
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          services {
            id
            name
          }
        }
      }
    }
  }
`;
